import React, { useState, useEffect, Fragment, useRef } from "react";
import SidebarStrain from './SidebarStrain';
import {
    Avatar, Box, Button, Grid, Paper, Table, TableCell, TableContainer, TableBody, TableHead,
    TableRow, TextField, Typography, Card, CardContent, CardHeader, Tooltip, Modal, Divider, Backdrop, CircularProgress,
    Chip
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import DesktopWindowsOutlinedIcon from '@mui/icons-material/DesktopWindowsOutlined';
import { DataGrid, GridToolbar, GridToolbarExport } from '@mui/x-data-grid';
import CloseIcon from '@mui/icons-material/Close';

import IconButton from '@mui/material/IconButton';
import config from '../../../config.json'
import moment from "moment";
import CountUp from 'react-countup';
import axios from 'axios';
import { disableBackButton } from '../../ConstantComponents/Constants'
import Footer from "../../Footer";
import HourglassBottomRoundedIcon from '@mui/icons-material/HourglassBottomRounded';

const useStyle = makeStyles({
    root: {
        "& .MuiDataGrid-columnHeaderTitle": {

            whiteSpace: "pre-wrap",
            lineHeight: 1,
            textAlign: "center",
            fontWeight: "bold",
            color: "#ba7704",
            fontSize: '1.1rem',
            height: 80,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        '& .MuiDataGrid-columnHeader': {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        "& .MuiDataGrid-cellContent": {
            textOverflow: "clip",
            whiteSpace: "pre-wrap",
            lineHeight: 1,
            textAlign: "center",
            fontWeight: "bold",
        },
        "& .MuiTypography-string": {
            textOverflow: "ellipsis",
            whiteSpace: "break-spaces",
            lineHeight: 1,
            textAlign: "center",
            fontWeight: "bold",

        },
        boxShadow: 2,
        "& .MuiTablePagination-selectLabel": {
            marginTop: "auto",
        },
        "& .MuiTablePagination-displayedRows": {
            marginTop: "auto",
        },
    },
});

const BASE_URL = config.SERVER_URL;

export default function GenomeSequence() {

    disableBackButton()

    const drawerWidth = 260;

    const [getgenome, setgetgenome] = useState([])

    const [viewformModal, setviewformModal] = useState(false)

    const [backdropopen, setbackdropopen] = useState(true)

    const [loading, setloading] = useState(true);

    const [pageSize, setPageSize] = useState(10);

    const [nicedstrainidview, setnicedstrainidview] = useState('')

    const [testsubcategorynameview, settestsubcategorynameview] = useState('')
    const [testpropertyview, settestpropertyview] = useState('')
    const [serotypeview, setserotypeview] = useState('')
    const [samplecategoryview, setsamplecategoryview] = useState('')
    const [samplesubcategoryview, setsamplesubcategoryview] = useState('')
    const [icmrsampleid, seticmrsampleid] = useState('')
    const [supercategorynameview, setsupercategorynameview] = useState('')
    const [statename, setstatename] = useState('')
    const [districtname, setdistrictname] = useState('')
    const [centername, setcentername] = useState('')
    const [ncbi, setncbi] = useState('')
    const [anti, setanti] = useState('')
    const [virulence, setvirulence] = useState('')
    const [mlst, setmlst] = useState('')

    const classes = useStyle();

    const style2 = {
        position: 'absolute',
        left: '50%',
        top: '50%',
        width: 'auto',
        maxHeight: '90vh',
        transform: 'translate(-50%, -50%)',
        margin: 'auto'


    }

    useEffect(() => {



        const getGenome = axios.post(BASE_URL+"/genome/getGenomeDetails",
            {},
            //{ withCredentials: true }
            //{ headers:  headers}
        );

        Promise.all([getGenome])
            .then(function (responses) {

                setloading(false)
                setgetgenome(responses[0].data.Genome);



                setbackdropopen(false)
            })
            .catch(function (errors) {

                //////console.log("strain errors", errors[0]);
            });

    }, [])

    /////////////////////////////// niced strain view col def  ///////////////////////////////////

    const columns = [

        {
            field: "icmrStrainId",
            headerName: "NICED Strain ID",
            flex: 1, align: 'center', headerAlign: 'center',
            renderCell: (params) => {
                return (
                    <>
                        <Typography variant="string" color=" blue" sx={{ cursor: 'pointer' }}
                            onClick={(event) => {
                                handleviewformModal(event, params);
                            }} >
                            {params.row.icmrStrainId}
                        </Typography>
                    </>
                )
            }
        },
        {
            field: "pathogen",
            headerName: "Pathogen Identified",
            flex: 1.5, align: 'center', headerAlign: 'center',
            renderCell: (params) => {
                return (<> <Typography variant="string" style={{ fontStyle: 'italic' }} >
                    {params.row.subcategoryName} &nbsp;
                </Typography>
                    <Typography variant="string" style={{ fontStyle: 'italic' }} >
                        {params.row.propertyName === "Positive" ? "" : `(${params.row.propertyName})\u00A0`}
                    </Typography>

                    <Typography variant="string" >
                        {params.row.serotype}
                    </Typography>
                </>)
            }
        },
        // {
        //     field: "serotype",
        //     headerName: "Serotype",
        //     flex: 1, align: 'center', headerAlign: 'center',
        //     renderCell: (params) => {
        //         return (<Typography variant="string" >
        //             {params.row.serotype}
        //         </Typography>)
        //     }
        // },
        {
            field: "mlstDetails",
            headerName: "MLST",
            flex: 0.5, align: 'center', headerAlign: 'center',
            // renderCell: (params) => {
            //     return (<Typography variant="string" >
            //         {moment(params.row.testDate).format('YYYY')}
            //     </Typography>)
            // }
        },
        {
            field: "virulenceDetails",
            headerName: "Virulence encoding gene",
            flex: 1, align: 'center', headerAlign: 'center',
            // renderCell: (params) => {
            //     return (<Typography variant="string" >
            //         {moment(params.row.testDate).format('YYYY')}
            //     </Typography>)
            // }
        },
        {
            field: "antiDetails",
            headerName: "Antimicrobial resistance encoding gene",
            flex: 1, align: 'center', headerAlign: 'center',
            // renderCell: (params) => {
            //     return (<Typography variant="string" >
            //         {moment(params.row.testDate).format('YYYY')}
            //     </Typography>)
            // }
        },
        {
            field: "ncbiDetails",
            headerName: "NCBI Sequence accession number",
            flex: 1, align: 'center', headerAlign: 'center',
            renderCell: (params) => {
                return (<>
                    <div>
                        {params.row.ncbiDetails === "In Progress" ?
                            <Chip label="In Progress" sx={{
                                backgroundColor: '#d9d032', // Custom background color
                                color: '#000000',
                            }} icon={<HourglassBottomRoundedIcon />} />
                            : params.row.ncbiDetails}
                    </div>
                </>)
            }
        },
        // {
        //     field: "View",
        //     renderCell: (cellValues) => {
        //         return (
        //             <IconButton
        //                 //   variant="contained"
        //                 //   color="primary"
        //                 //   size='medium'
        //                 //   startIcon={<EditIcon></EditIcon>}

        //                 onClick={(event) => {
        //                     //handleViewOpen(event, cellValues);
        //                     handleviewformModal(event, cellValues);
        //                 }}
        //             >
        //                 <DesktopWindowsOutlinedIcon></DesktopWindowsOutlinedIcon>
        //             </IconButton>
        //         );
        //     }, flex: 0.5, align: 'center', headerAlign: 'center'
        // }
    ];

    const handleviewformModal = (event,cellValues) => {
        setviewformModal(true)

        setnicedstrainidview(cellValues.row.icmrStrainId)
        settestsubcategorynameview(cellValues.row.subcategoryName)
        settestpropertyview(cellValues.row.propertyName)
        setserotypeview(cellValues.row.serotype)

        setsupercategorynameview(cellValues.row.superCategoryName)
        setsamplecategoryview(cellValues.row.sampleCategoryName)
        setsamplesubcategoryview(cellValues.row.sampleSubcategoryName)

        setstatename(cellValues.row.stateName)
        setdistrictname(cellValues.row.districtName)
        setcentername(cellValues.row.centerName)

        setmlst(cellValues.row.mlstDetails)
        setvirulence(cellValues.row.virulenceDetails)
        setanti(cellValues.row.antiDetails)
        setncbi(cellValues.row.ncbiDetails);
    }

    const handleviewformModalClose = () => {
        setviewformModal(false)
    }



    return (
        <>
            <Box
                sx={{
                    width: { sm: `calc(100% - ${drawerWidth}px)` },
                    ml: { sm: `${drawerWidth}px` }
                }}>
                <SidebarStrain />
                <div style={{ marginTop: '70px' }}>
                    <div className="body flex-grow-1" style={{ backgroundColor: '#f3f4f7', }}>
                        <div className="row p-3">

                            <div className="container" style={{ marginBottom: 200 }}>
                                <h2 className="rubik-font" style={{ fontWeight: 400, textAlign: 'center', marginBottom: 20, marginTop: 50, color: "black" }}>Whole Genome Analysis Details</h2>
                                <Box sx={{ height: 500, justifyContent: "center" }}>
                                    <DataGrid
                                        className={classes.root}
                                        sx={{
                                            boxShadow: 2,
                                            "& .MuiTablePagination-selectLabel": {
                                                marginTop: "auto",
                                            },
                                            "& .MuiTablePagination-displayedRows": {
                                                marginTop: "auto",
                                            },
                                            "& .MuiDataGrid-cell": {
                                                padding: 0.5,
                                            },
                                            overflowX: "hidden",
                                            borderRadius: 2,
                                            padding: 2,
                                            border: "1px solid",
                                            backgroundColor: "#ffffff"
                                        }}
                                        rows={getgenome}
                                        getRowId={(r) => r.seqId}
                                        columns={columns}

                                        loading={loading}
                                        pageSize={pageSize}
                                        onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                                        pagination
                                        rowsPerPageOptions={[10, 25, 50, 100]}
                                        disableVirtualization
                                        disableSelectionOnClick={true}
                                        rowHeight={50}
                                        disableRowSelectionOnClick
                                        enableColumnAutosize
                                        autoHeight
                                    />
                                </Box>
                            </div>

                        </div>
                    </div>
                </div>
            </Box>

            {/* view modal */}
            {/**view modal */}
            <Modal
                open={viewformModal}
                onClose={handleviewformModalClose}
                aria-labelledby="parent-modal-title"
                aria-describedby="parent-modal-description"
            >
                <Box sx={style2}>
                    <div style={{ alignItems: 'end', justifyItems: 'end', display: 'grid', marginBottom: '-40px' }}>
                        <Tooltip title='Close'>
                            <IconButton
                                sx={{
                                    color: 'rgb(255, 255, 255)'
                                }}
                                onClick={(event) => {
                                    handleviewformModalClose(event)


                                }}
                            >
                                <CloseIcon />
                            </IconButton>
                        </Tooltip>
                    </div>

                    <Card sx={{ width: '100%', height: 'auto', alignItems: 'center', boxShadow: 10, borderRadius: 3, display: 'grid', backgroundColor: "#ffffff" }}>
                        <CardHeader
                            title={'Strain ID: ' + ' ' + nicedstrainidview}
                            //subheader={'ICMR Sample ID: ' + ' ' + icmrsampleid}
                            style={{ textAlign: 'left' }}
                            titleTypographyProps={{ variant: 'h5', fontWeight: 'bold', color: 'white' }}
                            subheaderTypographyProps={{ variant: 'h6', fontWeight: 'bold', color: 'white' }}
                            sx={{ justifyContent: 'center', display: 'grid', background: '#45a2fa' }}

                        >
                        </CardHeader>
                        {/* <Divider sx={{ bgcolor: "secondary.light" }} orientation="horizontal" flexItem /> */}
                        <Divider style={{ width: '500%', background: 'black' }} >

                        </Divider>


                        <CardContent>

                            <Box
                                component="form"
                                sx={{

                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    overflowY: 'auto',
                                    height: '500px'

                                }}
                                noValidate
                                autoComplete="off"
                            >
                                <Grid container spacing={1} >
                                    <Grid item xs={12}>
                                        <h4 className="rubik-font" style={{ fontFamily: 'Rubik, sans-serif', color: 'black', textAlign: 'center' }}>Sample Details</h4>
                                        <Divider orientation="horizontal" sx={{ backgroundColor: 'blue', height: 2 }}></Divider>
                                    </Grid>
                                    <Grid item xs={6} md={3} sx={{ alignItems: 'center', justifyContent: 'right', display: 'grid' }}>

                                        <Typography sx={{ fontWeight: 500, fontFamily: 'Rubik, sans-serif', }} variant="subtitle1">
                                            SuperCategory:
                                        </Typography>

                                    </Grid>
                                    <Grid item xs={6} md={3}>

                                        <Typography variant="subtitle1" >
                                            {supercategorynameview}
                                        </Typography>

                                    </Grid>

                                    <Grid item xs={6} md={3} sx={{ alignItems: 'center', justifyContent: 'right', display: 'grid' }}>

                                        <Typography sx={{ fontWeight: 500, fontFamily: 'Rubik, sans-serif', }} variant="subtitle1" >
                                            Sample Category:
                                        </Typography>

                                    </Grid>
                                    <Grid item xs={6} md={3}>

                                        <Typography variant="subtitle1" >
                                            {samplecategoryview}
                                        </Typography>

                                    </Grid>
                                    <Grid item xs={6} md={3} sx={{ alignItems: 'center', justifyContent: 'right', display: 'grid' }}>

                                        <Typography sx={{ fontWeight: 500, fontFamily: 'Rubik, sans-serif', }} variant="subtitle1">
                                            Sample Sub-Category:
                                        </Typography>

                                    </Grid>
                                    <Grid item xs={6} md={3}>

                                        <Typography variant="subtitle1" >
                                            {samplesubcategoryview}
                                        </Typography>

                                    </Grid>

                                    {/* <Grid item xs={6} md={3} sx={{ alignItems: 'center', justifyContent: 'right', display: 'grid' }}>

                                        <Typography sx={{ fontWeight: 500, fontFamily: 'Rubik, sans-serif', }} variant="subtitle1" >
                                            Isolation Year:
                                        </Typography>

                                    </Grid>
                                    <Grid item xs={6} md={3}>

                                        <Typography variant="subtitle1" >
                                            {moment(testdate).format("YYYY")}
                                        </Typography>

                                    </Grid> */}
                                    <Grid item xs={6} md={3} sx={{ alignItems: 'center', justifyContent: 'right', display: 'grid' }}>

                                        <Typography sx={{ fontWeight: 500, fontFamily: 'Rubik, sans-serif', }} variant="subtitle1">
                                            State:
                                        </Typography>

                                    </Grid>
                                    <Grid item xs={6} md={3}>

                                        <Typography variant="subtitle1" >
                                            {statename}
                                        </Typography>

                                    </Grid>

                                    {/* <Grid item xs={6} md={3} sx={{ alignItems: 'center', justifyContent: 'right', display: 'grid' }}>

                                        <Typography sx={{ fontWeight: 500, fontFamily: 'Rubik, sans-serif', }} variant="subtitle1" >
                                            District:
                                        </Typography>

                                    </Grid>
                                    <Grid item xs={6} md={3}>

                                        <Typography variant="subtitle1" >
                                            {districtname}
                                        </Typography>

                                    </Grid> */}
                                    
                                    <Grid item xs={12} md={12} sx={{ alignItems: 'center', justifyContent: 'center', display: 'flex' }}  >

                                        <Typography sx={{ fontWeight: 500, fontFamily: 'Rubik, sans-serif', textAlign: 'center' }} variant="subtitle1">
                                            District: &nbsp;
                                        </Typography>
                                        <Typography variant="subtitle1" >
                                            {districtname}
                                        </Typography>

                                    </Grid>
                                    <Grid item xs={12} md={12} sx={{ alignItems: 'center', justifyContent: 'center', display: 'flex' }}  >

                                        <Typography sx={{ fontWeight: 500, fontFamily: 'Rubik, sans-serif', textAlign: 'center' }} variant="subtitle1">
                                            Center: &nbsp;
                                        </Typography>
                                        <Typography variant="subtitle1" >
                                            {centername}
                                        </Typography>

                                    </Grid>
                                    <Grid item xs={6} md={6}>



                                    </Grid>

                                    <Grid item xs={12}>
                                        <h4 className="rubik-font" style={{ fontFamily: 'Rubik, sans-serif', color: 'black', textAlign: 'center' }}>Pathogen Details</h4>
                                        <Divider orientation="horizontal" sx={{ backgroundColor: 'blue', height: 2 }}></Divider>
                                    </Grid>
                                    <Grid item xs={6} md={6} sx={{ alignItems: 'center', justifyContent: 'right', display: 'grid' }}>

                                        <Typography sx={{ fontWeight: 500, fontFamily: 'Rubik, sans-serif' }} variant="subtitle1">
                                            Identified pathogen:
                                        </Typography>

                                    </Grid>
                                    <Grid item xs={6} md={6}>

                                        <Typography variant="subtitle1" sx={{ fontStyle: 'italic' }} >
                                            {testsubcategorynameview} {testpropertyview === "Positive" ? "" : `(${testpropertyview})`}
                                        </Typography>

                                    </Grid>

                                    <Grid item xs={6} md={6} sx={{ alignItems: 'center', justifyContent: 'right', display: 'grid' }}>

                                        <Typography sx={{ fontWeight: 500, fontFamily: 'Rubik, sans-serif' }} variant="subtitle1" >
                                            Serotype:
                                        </Typography>

                                    </Grid>
                                    <Grid item xs={6} md={6}>

                                        <Typography variant="subtitle1" >
                                            {serotypeview ? serotypeview : "Not Available"}
                                        </Typography>

                                    </Grid>
                                    <Grid item xs={12} >

                                        <h4 className="rubik-font" style={{ fontFamily: 'Rubik, sans-serif', color: 'black', textAlign: 'center' }}>Antibiogram and Virulence Genes Details</h4>
                                        <Divider orientation="horizontal" sx={{ backgroundColor: 'blue', height: 2 }}></Divider>
                                    </Grid>
                                    <Grid item xs={6} md={6} sx={{ alignItems: 'center', justifyContent: 'right', display: 'grid' }}>

                                        <Typography sx={{ fontWeight: 500, fontFamily: 'Rubik, sans-serif' }} variant="subtitle1">
                                            Multilocus sequence type (MLST):
                                        </Typography>

                                    </Grid>
                                    <Grid item xs={6} md={6}>

                                        <Typography variant="subtitle1" >
                                            {mlst}
                                        </Typography>

                                    </Grid>

                                    <Grid item xs={6} md={6} sx={{ alignItems: 'center', justifyContent: 'right', display: 'grid' }}>

                                        <Typography sx={{ fontWeight: 500, fontFamily: 'Rubik, sans-serif' }} variant="subtitle1" >
                                            Virulence encoding gene:
                                        </Typography>

                                    </Grid>
                                    <Grid item xs={6} md={6}>

                                        <Typography variant="subtitle1" sx={{ fontStyle: 'italic' }} >
                                            {virulence}
                                        </Typography>

                                    </Grid>
                                    <Grid item xs={6} md={6} sx={{ alignItems: 'center', justifyContent: 'right', display: 'grid' }}>

                                        <Typography sx={{ fontWeight: 500, fontFamily: 'Rubik, sans-serif' }} variant="subtitle1" >
                                            Antimicrobial resistance encoding gene:
                                        </Typography>

                                    </Grid>
                                    <Grid item xs={6} md={6}>

                                        <Typography variant="subtitle1" sx={{ fontStyle: 'italic' }}>
                                            {anti}
                                        </Typography>

                                    </Grid>
                                    <Grid item xs={6} md={6}>

                                        <Typography sx={{ fontWeight: 500, fontFamily: 'Rubik, sans-serif', alignItems: 'center', justifyContent: 'right', display: 'grid' }} variant="subtitle1" >
                                            NCBI Sequence accession number:
                                        </Typography>

                                    </Grid>
                                    <Grid item xs={6} md={6}>

                                        {ncbi === "In Progress" ? <Chip label="In Progress" sx={{
                                            backgroundColor: '#d9d032', // Custom background color
                                            color: '#000000',
                                        }} icon={<HourglassBottomRoundedIcon />} /> : <Typography variant="subtitle1" >
                                            {ncbi}
                                        </Typography>}



                                    </Grid>



                                </Grid>
                            </Box>


                        </CardContent>



                    </Card>


                </Box>
            </Modal>

            <Backdrop
                sx={{ color: "#000000", zIndex: (theme) => theme.zIndex.drawer + 1, backgroundColor: 'rgba(255,255,255,0.9)' }}
                open={backdropopen}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </>
    )
}
